module.exports = {
  model: { id: '', name: null, value: null, description: null },
  required: ['name', 'value', 'description']
}
